var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"fj-env",rawName:"v-fj-env"},{name:"fj-touch",rawName:"v-fj-touch"}],staticClass:"breadcrumb-item",class:{ 'breadcrumb-item-clickable': _vm.clickable },on:{"click":_vm.onClick}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }